import { createServer } from 'miragejs';



import {
  BranchProgressState,
  ValidationFailureReason,
} from '../app/models/branch.model'


// import { PROCESS_STATUS } from '../app/pages/upload/upload-file/upload-file.component'

export const PROCESS_STATUS = [
  'UPLOAD_VALIDATED',
  'UPLOAD_PROCESSED',
  'ADDRESS_VALIDATION_DUPLICATE_CHECKED',
  'ADDRESS_VALIDATION_ADDRESS_CHECKED',
] as const satisfies BranchProgressState[]

export function create(): void {
  createServer({
    routes(): void {
      // this.namespace = 'api'

      const processingLimit = 5
      const branchId = 'my-supper-branch-id-foooo'
      const s3MockUrl =
        'https://csv-uploads-bucket.s3.amazonaws.com/dev/' + branchId

      let processingCount = processingLimit
      let activeStatus = -1

      this.post(
        '/api/branches',
        () => {
          return {
            branchId: branchId,
            signedUrl: s3MockUrl,
            expiresIn: 3600,
          }
        },
        { timing: 2000 }
      )
      this.put(
        `${s3MockUrl}`,
        () => {
          return {}
        },
        { timing: 3000 }
      )
      this.get('/api/branches/:id/state', (schema, request) => {
        if (processingCount <= 0) {
          processingCount = processingLimit
          if (activeStatus < PROCESS_STATUS.length) activeStatus++
        } else {
          processingCount--
        }

        // return {
        //   branchId: request.params.id,
        //   processState: PROCESS_STATUS[activeStatus],
        //   updatedAt: '2024-07-18T10:30:00.000Z',
        // }
        return {
          branchId: request.params.id,
          state: 'WORKFLOW_INITIAL',
          processState: 'UPLOAD_FAILED',
          processFailureReason: {
            error: 'UPLOAD_VALIDATION_DATA_FAILED',
            message: JSON.stringify({
              error_count: 33,
              pre_signed_url:
                'https://csv-uploads-bucket.s3.amazonaws.com/dev/dadada',
            } satisfies ValidationFailureReason),
          },
          updatedAt: '2024-07-18T10:30:00.000Z',
        }
      })

      this.passthrough()
    },
  })
}
